// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".decision_qpc_list-module__solution--1Q_r3{color:#616161}\n", ""]);
// Exports
exports.locals = {
	"solution": "decision_qpc_list-module__solution--1Q_r3"
};
module.exports = exports;
